<div class="copyable-block" [class.copyable-block--user]="variant() === 'user'">
  <button
    class="copyable-copy"
    type="button"
    [attr.aria-label]="chatWordings.copy()"
    [attr.title]="_copied() ? chatWordings.copied() : chatWordings.copy()"
    (click)="copy()"
  >
    <i [class]="_copied() ? 'myre-icon-check' : 'myre-icon-copy'"></i>
    <span class="copyable-copy-label">{{
      _copied() ? chatWordings.copied() : chatWordings.copy()
    }}</span>
  </button>
  <div class="copyable-content markdown" [innerHTML]="html()"></div>
</div>
